import React from 'react';
import logo from '../../assets/skillsChecker.png';

const SkillCheckerLogo = ({ height }) => (
  <img
    src={logo}
    alt="edulai"
    className="logo"
    style={{
      alignSelf: 'center',
      height,
    }}
  />
);

export default SkillCheckerLogo;
